<template>
	<div class="divscanprint" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
		<el-row style="margin-top:50px">
			<el-col :span="7" style="color:transparent">1</el-col>
			<el-col :span="10">
				<el-form ref="form" label-width="120px">
					<el-form-item label="打印模板" class="scaninput">
						<el-select v-model="e_modename" style="width:100%" @change="selectmode">
							<el-option v-for="(item, index) in modelist" :key="index" :label="item.e_modename" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="扫描单号" class="scaninput">
						<el-input type="text" v-model="pkval" ref="pkval" :disabled="disabled" @keyup.native="checkorder"></el-input>
					</el-form-item>
				</el-form>
				<div style="text-align: center;margin-top:50px">
					<span style="color:blue;font-size:23pt;">已扫描 {{ count }} 单</span>
				</div>
			</el-col>
		</el-row>

		<printhandler ref="printhandler" @printcallback="printcallback"></printhandler>
		<errorwin ref="errorwin" @errorwincallback="errorwincallback"></errorwin>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import printhandler from '@/components/order/printhandler.vue';
import errorwin from '@/components/tools/errorwin.vue';
export default {
	components: {
		errorwin,
		printhandler
	},
	props: {},
	data() {
		return {
			showscanprint: false,
			modelist: [],
			divclass: 'scanprint',
			p_mode: '',
			e_code: '',
			e_modename: '',
			pkval: '',
			disabled: false,
			count: 0,
			windowHeight: window.innerHeight - 150
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/packagemanager/scanprint.scss');
			this.init();
		});
	},
	methods: {
		init() {
			this.showscanprint = true;
			this.disabled = true;
			this.modelist = [];
			this.p_mode = '';
			this.e_code = '';
			this.e_modename = '';
			this.pkval = '';
			//获取打印模板
			this.GetPrintTemplate();
		},
		GetPrintTemplate() {
			var that = this;
			this.$tool.loading('正在获取模板', this.divclass);
			this.$apipost.get.GetPrintTemplate().then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					if (res.list.length > 0) {
						that.disabled = false;
						that.p_mode = res.list[0].p_mode;
						that.e_modename = res.list[0].e_modename;
						that.e_code = res.list[0].id;
					}
					that.modelist = res.list;
					this.$nextTick(function() {
						that.$refs.pkval.focus();
					});
				}
			});
		},
		selectmode(val) {
			//debugger
			var list=this.modelist.filter(function(e){
				return e.id==val;
			});
			if(list.length>0)
			{
				this.p_mode = list[0].p_mode;
				this.e_modename = list[0].e_modename;
				this.e_code = list[0].id;
			}
		},
		checkorder(e) {
			if (e.keyCode == 13) {
				var that = this;
				var pkval=this.pkval.replace(/ /, '').replace(/\t/g,'').trim();
				if ( pkval!= '') {
					this.disabled = true;
					var paraminfo = {
						p_mode: this.p_mode,
						userid: localStorage.getItem('userid'),
						pkval: pkval
					};
					this.$apipost.get.CheckScanOrder({ paraminfo: paraminfo }).then(res => {
						if (res.state == '1') {
							//this.$tool.loading('正在打印', 'packagelist');
							if (this.$refs.printhandler != undefined) {
								this.$refs.printhandler._data.handtype = 13;
								this.$refs.printhandler._data.pageparam = this._data;
								var list = [{ pkval: res.pkval, e_code: that.e_code, e_modename: that.e_modename }];
								this.$refs.printhandler.ForPrint(list, 0);
							} else {
								this.$tool.message('打印组件未加载，请关闭窗口重试', 0);
							}
						} else {
							if (that.$refs.errorwin != undefined) {
								that.$refs.errorwin.init({ errormsg: res.message });
							}
						}
					});
				}
			}
		},
		printcallback(e) {
			var pkval = '',
				batch = '';
			this.pkval = '';
			var that=this;
			//debugger
			this.disabled = false;
			if (e.issuccess) {
				this.count=parseInt(this.count)+1;
				if (e.handtype == 13) {
					if (e.p_pkval != '') {
						pkval = e.p_pkval;
					}
					if (e.batch != '') {
						batch = e.batch;
					}
					var paraminfo = {
						p_pkval: pkval,
						batch: batch
					};
					//更新打印状态和打印次数
					this.$apipost.post.UpdatePrintState({ paraminfo: paraminfo }).then(res => {});
				}
				this.ReadMsg('成功');
				this.$nextTick(function() {
					that.$refs.pkval.focus();
				});
			} else {
				if (this.$refs.errorwin != undefined) {
					this.$refs.errorwin.init({ errormsg: e.errormsg });
				}
			}
		},
		ReadMsg(msg) {
			if (this.$tool.checkprintcontrol()) {
				LODOP.FORMAT('VOICE:3;100', msg);
			}
		},
		errorwincallback(e) {
			var that=this;
			this.pkval = '';
			this.disabled = false;
			if(e.type=='close'){
				this.$nextTick(function() {
					that.$refs.pkval.focus();
				});
			}
		}
	}
};
</script>

<style lang="scss">
.scaninput .el-form-item__label {
	height: 60px;
	font-size: 20pt;
	line-height: 60px;
}
.scaninput .el-input__inner {
	height: 60px;
	font-size: 25pt;
	font-weight: bold;
}
</style>
